import { SECTIONS } from './types';

export function scrollToSection(section: keyof typeof SECTIONS) {
  const element = document.getElementById(section);
  return element.scrollIntoView({ behavior: 'smooth' });
}
